import ProvideMessage, { useMessage } from './messageContext';

export { useMessage };

export default ProvideMessage;
